import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04fd3846"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "headerContainer" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " more_vert ", -1))
const _hoisted_4 = {
  key: 0,
  class: "headerContainer__filters"
}
const _hoisted_5 = {
  key: 0,
  class: "headerContainer__filters__filter--project"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Categoría", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "all" }, "Todos", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 1,
  class: "headerContainer__filters__filter--project"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Empresa", -1))
const _hoisted_13 = {
  key: 0,
  value: "all"
}
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "headerContainer__filters__filter--project" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<option value disabled data-v-04fd3846>Estado</option><option value=\"all\" data-v-04fd3846>Todos</option><option value=\"todo\" data-v-04fd3846>Por hacer</option><option value=\"progress\" data-v-04fd3846>En Progreso</option><option value=\"done\" data-v-04fd3846>Hecho</option>", 5)
const _hoisted_22 = [
  _hoisted_17
]
const _hoisted_23 = {
  key: 1,
  class: "headerContainer__filters"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " home ", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Producto", -1))
const _hoisted_27 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactModal = _resolveComponent("ContactModal")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!
  const _component_UserOptionsModal = _resolveComponent("UserOptionsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ModalComponent, {
      open: _ctx.openModalContact,
      onCloseModal: _ctx.closeContactModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ContactModal, {
          "contact-data": _ctx.contactData,
          "project-id": _ctx.projectId,
          onUpdateContactInfo: _ctx.emitUpdateContacInfo
        }, null, 8, ["contact-data", "project-id", "onUpdateContactInfo"])
      ]),
      _: 1
    }, 8, ["open", "onCloseModal"]),
    _createVNode(_component_ModalComponent, {
      open: _ctx.openModalUser,
      onCloseModal: _ctx.closeUserModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_UserOptionsModal)
      ]),
      _: 1
    }, 8, ["open", "onCloseModal"]),
    _createElementVNode("div", {
      class: "headerContainer__user",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openUserModal && _ctx.openUserModal(...args)))
    }, [
      _createElementVNode("img", {
        class: "headerContainer__user__image",
        src: _ctx.getUrlProfileImage,
        alt: ""
      }, null, 8, _hoisted_2),
      _createElementVNode("h4", null, _toDisplayString(_ctx.getHeaderName), 1),
      _hoisted_3
    ]),
    (_ctx.headerType === 'projects')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.isUserAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: _ctx.categoryIcon,
                  alt: ""
                }, null, 8, _hoisted_6),
                _withDirectives(_createElementVNode("select", {
                  "aria-placeholder": "Category",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterCategory) = $event)),
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeFilterCategory && _ctx.changeFilterCategory(...args)))
                }, [
                  _hoisted_7,
                  _hoisted_8,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: category.category_id,
                      key: category.category_id
                    }, _toDisplayString(category.name), 9, _hoisted_9))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.filterCategory]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isUserAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: _ctx.enterpriseIcon,
                  alt: ""
                }, null, 8, _hoisted_11),
                _withDirectives(_createElementVNode("select", {
                  "aria-placeholder": "Enterprise",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterEnterprise) = $event)),
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeFilterEnterprise && _ctx.changeFilterEnterprise(...args)))
                }, [
                  _hoisted_12,
                  (_ctx.isUserAdmin)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_13, "Todas"))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqueEnterprises, (enterprise) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: enterprise.enterprise_id,
                      key: enterprise.enterprise_id
                    }, _toDisplayString(enterprise.name), 9, _hoisted_14))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.filterEnterprise]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              src: _ctx.stateIcon,
              alt: ""
            }, null, 8, _hoisted_16),
            _withDirectives(_createElementVNode("select", {
              "aria-placeholder": "Estado",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterState) = $event)),
              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.changeFilterState && _ctx.changeFilterState(...args)))
            }, _hoisted_22, 544), [
              [_vModelSelect, _ctx.filterState]
            ])
          ])
        ]))
      : (_ctx.headerType === 'products')
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args))),
              class: "button--home"
            }, _hoisted_25),
            (_ctx.products.length > 0)
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 0,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.productPicked) = $event)),
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.clickOnProducts && _ctx.clickOnProducts(...args))),
                  class: "headerContainer__filters__filter--product",
                  "aria-placeholder": "Producto",
                  onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.changeProduct && _ctx.changeProduct(...args)))
                }, [
                  _hoisted_26,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: product.id,
                      key: product.id
                    }, _toDisplayString(product.name), 9, _hoisted_27))
                  }), 128))
                ], 544)), [
                  [_vModelSelect, _ctx.productPicked]
                ])
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.openContactModal && _ctx.openContactModal(...args))),
              class: "button--contact"
            }, " Contacto ")
          ]))
        : _createCommentVNode("", true)
  ]))
}